import React from 'react';
export const UrgencyBar = () => {
  return <div className="sticky top-0 z-50 w-full bg-cta py-2 px-4 shadow-lg" data-id="element-344" />;
};